import React from "react";
import { FaLayerGroup, FaCoins, FaEthereum, FaShieldAlt } from "react-icons/fa";

function FeatureStep({ Icon, title, description }) {
  return (
    <div className="feature-style-one hover-active-item">
      <div className="content d-flex flex-column items-center">
        <div className="icon">
          <Icon size={40} />
        </div>
        <h4>{title}</h4>
        <p>{description}</p>
      </div>
      <img
        src="https://validthemes.net/site-template/robok/assets/img/shape/9.png"
        alt="Image Not Found"
      />
    </div>
  );
}

function ReducedCosts() {
  const features = [
    {
      title: "Modularity & Flexibility",
      description:
        "OP Stack’s modular design allows for customized solutions, supporting rapid deployment and optimized scalability.",
      Icon: FaLayerGroup,
    },
    {
      title: "Reduced Costs",
      description:
        "Optimistic rollups on OP Stack significantly lower transaction fees, enabling cost-effective DApp solutions.",
      Icon: FaCoins,
    },
    {
      title: "Ethereum Compatibility",
      description:
        "OP Stack’s framework ensures easy migration of Ethereum-based applications and protocols.",
      Icon: FaEthereum,
    },
    {
      title: "Security & Efficiency",
      description:
        "OP Stack enhances network security while enabling efficient, high-speed transactions across layer-2 networks.",
      Icon: FaShieldAlt,
    },
  ];

  return (
    <div
      className="feature-style-one-area default-padding bg-gray blurry-shape-right-bottom"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/3.png)",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <div className="site-heading">
              <h4 className="sub-title">Our Features</h4>
              <h2 className="title split-text-right split-text-in-right split-lines">
                Benefits of OP Stack with Xeer Technology
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="fade-up-anim">
          <div className="row">
            <div className="col-xl-12">
              <div className="feature-style-one-items">
                {features.map((feature, idx) => (
                  <FeatureStep key={idx} {...feature} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReducedCosts;
